import { createSelector } from 'reselect';

const getState = (state) => state.menu;

export const getCollapseMenuState = createSelector(getState, (state) => state.collapseMenuState);
